import React, { useEffect, useState } from 'react';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BackImage from 'components/BackImage';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import countries from 'components/LoginForm/Register/data/countries';
import { storageKeys } from 'config/settings.json';
import i18n from 'i18n-react';

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
  });

  return inputArray.every((val) => val.checkValidity() === true) && selectArray.every((val) => val.selectedIndex !== 0);
};

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  const emptyFields = [];

  inputArray.forEach((input) => {
    if (input.checkValidity() === false) {
      let name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 1') {
        name = 'salutation';
      }
      if (name === 'passwordConfirm') {
        name = 'confirm password';
      }
      emptyFields.push(name);
    }
  });

  selectArray.forEach((select) => {
    if (select.selectedIndex === 0) {
      let name = select.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'agency affiliation') {
        name = 'consortia affiliation';
      }
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const PreRegisterView = () => {
  const [userInput, setUserInput] = useState({
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_country: '',
  });
  const [logo, setLogo] = useState(null);
  const [welcomePageCopy, setWelcomePageCopy] = useState(null);
  const [isRegistered, setIsRegistered] = useState(false);
  // const [destination, setDestination] = useState(null);

  const changeHandler = (event) => {
    const { name, type, value, checked } = event.target;
    const nextValue = type === 'checkbox' ? checked : value;
    setUserInput((prev) => ({ ...prev, [name]: nextValue }));
  };

  const registerHandler = (event) => {
    event.preventDefault();
    const submit = event.target;
    submit.disabled = true;
    if (checkInputValidity()) {
      const info = userInput;

      const registerObject = {
        email: info.reg_email,
        first_name: info.reg_first_name,
        last_name: info.reg_last_name,
        agency_name: info.reg_agency_name,
        country: info.reg_country,
      };

      DataHandler.matchAppId().then((appId) => {
        APIHandler.setUser(appId, registerObject)
          .then((setUserResponse) => {
            // As any API Errors are handled by the APIHandler, we check explicitly for the response.result being 'success'. If not, we treat it as a generic error.
            if (!setUserResponse || setUserResponse?.result !== 'success') {
              toast.error(i18n.translate('preregisterView.somethingWentWrong'), {
                position: 'top-center',
                transition: Zoom,
                autoClose: 10000,
                hideProgressBar: true,
                pauseOnHover: true,
                draggable: true,
              });
              submit.disabled = false;
              return;
            }
            APIHandler.getUserOld(appId, info.reg_email).then((newUser) => {
              if (newUser.result === 'success') {
                // Save registration status to local storage
                StorageHandler.save(storageKeys.preRegistered, { registered: true, email: info.reg_email });
                setIsRegistered(true);
                toast.success(i18n.translate('preregisterView.success'), {
                  position: 'top-center',
                  transition: Zoom,
                  autoClose: 10000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });
              }
              return newUser;
            });
          })
          .catch(() => {
            toast.error(i18n.translate('preregisterView.somethingWentWrong'), {
              position: 'top-center',
              transition: Zoom,
              autoClose: 10000,
              hideProgressBar: true,
              pauseOnHover: true,
              draggable: true,
            });
            submit.disabled = false;
          });
      });
    } else {
      const invalidFields = i18n.translate('preregisterView.fillRequired', {
        fields: checkInputValidityFields().join(', '),
      });
      // const invalidFields = `Please fill in all the required fields: ${checkInputValidityFields().join(', ')}`;
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
    }
  };

  useEffect(() => {
    async function getAppInfo() {
      const appInfo = await StorageHandler.load(storageKeys.appInfo);
      if (appInfo) {
        setLogo(appInfo.logo);
        setWelcomePageCopy(appInfo.welcomePageCopy);
      }
    }
    getAppInfo();

    // Check if user is already registered
    async function checkRegistrationStatus() {
      const registrationStatus = await StorageHandler.load(storageKeys.preRegistered);
      if (registrationStatus && registrationStatus.registered) {
        setIsRegistered(true);
      }
    }
    checkRegistrationStatus();
  }, []);

  // TODO: Form validation required?

  return (
    <div className="preRegisterView">
      <BackImage darken />
      <div className="preRegisterView__wrapper">
        {logo && <img src={logo} alt="logo" className="preRegisterView__logo" />}
        {welcomePageCopy && <div dangerouslySetInnerHTML={{ __html: welcomePageCopy }} />}

        {!isRegistered && (
          <div className="preRegisterView__form">
            <div className="preRegisterView__form--inputfield">
              <label htmlFor="reg_email" id="reg_email">
                {i18n.translate('preregisterView.email')} {'*'}
              </label>
              <input
                id="reg_email"
                name="reg_email"
                type="email"
                placeholder="Email"
                onChange={changeHandler}
                required
              />
            </div>
            <div className="preRegisterView__form--inputfield">
              <label htmlFor="reg_first_name" id="reg_first_name">
                {i18n.translate('preregisterView.firstName')} {'*'}
              </label>
              <input
                id="reg_first_name"
                name="reg_first_name"
                type="text"
                placeholder="First Name"
                onChange={changeHandler}
                required
              />
            </div>
            <div className="preRegisterView__form--inputfield">
              <label htmlFor="reg_last_name" id="reg_last_name">
                {i18n.translate('preregisterView.lastName')} {'*'}
              </label>
              <input
                id="reg_last_name"
                name="reg_last_name"
                type="text"
                placeholder="Last Name"
                onChange={changeHandler}
                required
              />
            </div>
            <div className="preRegisterView__form--inputfield">
              <label htmlFor="reg_agency_name" id="reg_agency_name">
                {i18n.translate('preregisterView.agencyName')} {'*'}
              </label>
              <input
                id="reg_agency_name"
                name="reg_agency_name"
                type="text"
                placeholder="Agency Name"
                onChange={changeHandler}
                required
              />
            </div>

            <div className="preRegisterView__form--inputfield">
              <label htmlFor="reg_country" id="reg_country">
                {i18n.translate('preregisterView.country')} {'*'}
              </label>
              <select
                id="reg_country"
                name="reg_country"
                value={userInput.reg_country}
                onChange={changeHandler}
                required
              >
                <option value="" disabled>
                  {i18n.translate('preregisterView.selectDefault')}
                </option>
                {countries.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="disclaimer">
              <p>{i18n.translate('preregisterView.requiredFields')}</p>
            </div>
            <div className="preRegisterView__form--button">
              <button type="submit" name="subscribe" id="submit" onClick={registerHandler}>
                {i18n.translate('preregisterView.submit')}
              </button>
            </div>
          </div>
        )}
        {isRegistered && (
          <div className="preRegisterView__success">
            <p>{i18n.translate('preregisterView.isRegistered')}</p>
          </div>
        )}
        <ToastContainer draggablePercent={70} />
        <style>
          {`
            .cookieConsent { display: none; }
          `}
        </style>
      </div>
    </div>
  );
};

export default PreRegisterView;
